// Path: /home/jason/src/AgileView/autovision-ui/src/components/wizards/UploadDatasetNameStep.tsx

// src/components/wizards/DatasetNameStep.tsx
import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useProject } from './NewProjectContext'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { setUploadSource } from '../../store/slices/datasetSlice'
import DatasetSelectorStepTable from './DatasetSelector'
import { useGetContentMetadataQuery } from '../../services/contentApi'
import { selectSelectedProjectId } from '../../store/slices/projectSlice'
import { useGetProjectQuery } from '../../services/projectsApi'
import { useDatasetStats } from '../../utils/datasetStats'

const UploadDatasetNameStep: React.FC = () => {
  const dispatch = useAppDispatch()
  const selectedProjectId = useAppSelector(selectSelectedProjectId)
  const { data: project } = useGetProjectQuery(selectedProjectId || '', {
    skip: !selectedProjectId,
  })
  const { setDatasetName, setDatasetSources } = useProject()
  const [localDatasets, setLocalDatasets] = useState<string[]>([])

  const { data: metadata } = useGetContentMetadataQuery(
    {
      project_id: selectedProjectId || '',
    },
    { skip: !selectedProjectId }
  )

  const handleAcceptSelections = (sources: string[]) => {
    if (!sources || !Array.isArray(sources)) {
      return // Early return if sources is invalid
    }

    if (sources.length > 0) {
      setDatasetName(sources[0])
      setDatasetSources(sources)
      dispatch(setUploadSource(sources[0]))
      setLocalDatasets((prev) => {
        const newDatasets = sources.filter(
          (ds) => !(metadata?.metadata?.datasource || []).includes(ds)
        )
        return [...new Set([...prev, ...newDatasets])]
      })
    } else {
      setDatasetName(undefined)
      setDatasetSources([])
    }
  }

  const availableDatasets = [
    ...new Set([...(metadata?.metadata?.datasource || []), ...localDatasets]),
  ]

  const datasetStats = useDatasetStats(
    selectedProjectId || '',
    project?.datasetid || '',
    availableDatasets
  )

  return (
    <Row>
      <Col>
        <DatasetSelectorStepTable
          singleSelect={true}
          canCreate={true}
          handleAcceptSelections={handleAcceptSelections}
          showAcceptButton={true}
          initialSelections={[]}
          availableDatasets={availableDatasets}
          datasetStats={datasetStats}
        />
      </Col>
    </Row>
  )
}

export default UploadDatasetNameStep
